import React, { PureComponent } from 'react'
import { string, bool } from 'prop-types'
import { Button as RButton } from 'reactstrap'
import { Icon } from 'components'

import './LinkButton.css'

export class LinkButton extends PureComponent {
    static propTypes = {
        children: string.isRequired,
        className: string,
        icon: string,
        iconClassName: string,
        uppercase: bool
    }

    static defaultProps = {
        uppercase: false
    }

    render() {
        const { className, children, icon, iconClassName, uppercase, ...otherProps } = this.props
        return (
            <RButton
                className={[
                    'LinkButton',
                    className,
                    {
                        Uppercase: uppercase
                    }
                ]}
                color="link"
                {...otherProps}
            >
                {icon ? (
                    <div className="flex row-center">
                        <Icon name={icon} className={iconClassName} />
                        <span>{children}</span>
                    </div>
                ) : (
                    children
                )}
            </RButton>
        )
    }
}



// WEBPACK FOOTER //
// src/components/Buttons/LinkButton/LinkButton.js